import classNames from 'clsx';
import type { SyntheticEvent } from 'react';
import React from 'react';
import ReactDOM from 'react-dom';
import { Manager, Popper, Reference } from 'react-popper';

import type { Props as DropDownProps } from '../LocalesDropDown';
// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../LocalesDropDown.scss';
import LocalesLink from '../LocalesLink/LocalesLink';
import LocalesMenu from '../LocalesMenu/LocalesMenu';

export interface Props extends DropDownProps {
  menuVisible: boolean;
  onClick: (e: SyntheticEvent) => void;
}

// TODO: refactor with `usePopper`
const LocalesPopper: React.FC<Props> = ({ className, menuVisible, onClick }) => (
  <Manager>
    <Reference>
      {({ ref }) => (
        <LocalesLink
          menuVisible={menuVisible}
          ref={ref}
          className={classNames(className, { [styles.closed]: !menuVisible })}
          onClick={onClick}
        />
      )}
    </Reference>
    {menuVisible &&
      ReactDOM.createPortal(
        <Popper
          modifiers={[
            {
              name: 'offset',
              options: {
                offset: [0, 15]
              }
            }
          ]}
        >
          {({ ref, style, arrowProps, placement }) => (
            <ul
              ref={ref}
              style={style}
              className={styles.popper}
              onClick={(e) => e.stopPropagation()}
              data-popper-placement={placement}
            >
              <li className={styles.arrow} {...arrowProps} />
              <LocalesMenu />
            </ul>
          )}
        </Popper>,
        // eslint-disable-next-line stars-web/no-direct-browser-globals-access
        document.getElementById('root') as HTMLElement
      )}
  </Manager>
);

export default LocalesPopper;
